import React from "react";
import { RaketaUIProvider, TextInput } from "@raketa-cms/raketa-cms";
import { MediaManagerContext } from "@raketa-cms/raketa-image-picker";
import MediaManager from "components/cms/MediaManager";
import InputSection from "./common/InputSection";
import TooltipInput from "./common/TooltipInput";

const mediaManager = new MediaManager("/");

const LabelsInput = ({ value, onChange }) => (
  <InputSection title="Common labels">
    <InputSection title="License type switcher">
      <TextInput
        label="Label"
        value={value.license_type_switcher}
        onChange={(license_type_switcher) =>
          onChange({ ...value, license_type_switcher })
        }
      />

      <TextInput
        label="License type switcher - commercial label"
        value={value.license_type_switcher_commercial}
        onChange={(license_type_switcher_commercial) =>
          onChange({ ...value, license_type_switcher_commercial })
        }
      />

      <TextInput
        label="License type switcher - educational label"
        value={value.license_type_switcher_educational}
        onChange={(license_type_switcher_educational) =>
          onChange({ ...value, license_type_switcher_educational })
        }
      />

      <InputSection title="Tooltip">
        <TooltipInput
          value={value.license_type_switcher_tooltip || {}}
          onChange={(license_type_switcher_tooltip) =>
            onChange({ ...value, license_type_switcher_tooltip })
          }
        />
      </InputSection>
    </InputSection>

    <InputSection title="Product switcher">
      <TextInput
        label="Title"
        value={value.change_product_title}
        onChange={(change_product_title) =>
          onChange({ ...value, change_product_title })
        }
      />
    </InputSection>

    <InputSection title="Plan/Billing period switcher">
      <TextInput
        label="Title"
        value={value.change_plan_title}
        onChange={(change_plan_title) =>
          onChange({ ...value, change_plan_title })
        }
      />

      <TextInput
        label="Sub Title"
        value={value.change_plan_subtitle}
        onChange={(change_plan_subtitle) =>
          onChange({ ...value, change_plan_subtitle })
        }
      />

      <TextInput
        label="Monthly label"
        value={value.billing_monthly}
        onChange={(billing_monthly) => onChange({ ...value, billing_monthly })}
      />

      <TextInput
        label="Monthly billed timing details (singular)"
        value={value.billing_monthly_license}
        onChange={(billing_monthly_license) =>
          onChange({ ...value, billing_monthly_license })
        }
        hint="Use the token {{LICENSES_COUNT}} to replace the number of licenses. Supports also {{PER_MONTH}}, {{PER_YEAR}}, {{PER_TRIENNIAL}} and {{SAVINGS}} tokens."
      />

      <TextInput
        label="Monthly billed timing details (multiple)"
        value={value.billing_monthly_licenses}
        onChange={(billing_monthly_licenses) =>
          onChange({ ...value, billing_monthly_licenses })
        }
        hint="Use the token {{LICENSES_COUNT}} to replace the number of licenses. Supports also {{PER_MONTH}}, {{PER_YEAR}}, {{PER_TRIENNIAL}} and {{SAVINGS}} tokens."
      />

      <TextInput
        label="Billed monthly"
        value={value.billed_monthly}
        onChange={(billed_monthly) => onChange({ ...value, billed_monthly })}
        hint="Supports also {{PER_MONTH}}, {{PER_YEAR}}, {{PER_TRIENNIAL}} and {{SAVINGS}} tokens."
      />

      <TextInput
        label="Annual label"
        value={value.billing_annual}
        onChange={(billing_annual) => onChange({ ...value, billing_annual })}
      />

      <TextInput
        label="Annual billed timing details (singular)"
        value={value.billing_anually_license}
        onChange={(billing_anually_license) =>
          onChange({ ...value, billing_anually_license })
        }
        hint="Use the token {{LICENSES_COUNT}} to replace the number of licenses. Supports also {{PER_MONTH}}, {{PER_YEAR}}, {{PER_TRIENNIAL}} and {{SAVINGS}} tokens."
      />

      <TextInput
        label="Annual billed timing details (multiple)"
        value={value.billing_anually_licenses}
        onChange={(billing_anually_licenses) =>
          onChange({ ...value, billing_anually_licenses })
        }
        hint="Use the token {{LICENSES_COUNT}} to replace the number of licenses. Supports also {{PER_MONTH}}, {{PER_YEAR}}, {{PER_TRIENNIAL}} and {{SAVINGS}} tokens."
      />

      <TextInput
        label="Billed anually"
        value={value.billed_annually}
        onChange={(billed_annually) => onChange({ ...value, billed_annually })}
        hint="Supports also {{PER_MONTH}}, {{PER_YEAR}}, {{PER_TRIENNIAL}} and {{SAVINGS}} tokens."
      />

      <TextInput
        label="3 years label"
        value={value.billing_triennial}
        onChange={(billing_triennial) =>
          onChange({ ...value, billing_triennial })
        }
      />

      <TextInput
        label="3 Year billed timing details (singular)"
        value={value.billing_triennial_license}
        onChange={(billing_triennial_license) =>
          onChange({ ...value, billing_triennial_license })
        }
        hint="Use the token {{LICENSES_COUNT}} to replace the number of licenses. Supports also {{PER_MONTH}}, {{PER_YEAR}}, {{PER_TRIENNIAL}} and {{SAVINGS}} tokens."
      />

      <TextInput
        label="3 Year billed timing details (multiple)"
        value={value.billing_triennial_licenses}
        onChange={(billing_triennial_licenses) =>
          onChange({ ...value, billing_triennial_licenses })
        }
        hint="Use the token {{LICENSES_COUNT}} to replace the number of licenses. Supports also {{PER_MONTH}}, {{PER_YEAR}}, {{PER_TRIENNIAL}} and {{SAVINGS}} tokens."
      />

      <TextInput
        label="Billed every 3 years"
        value={value.billed_triennially}
        onChange={(billed_triennially) =>
          onChange({ ...value, billed_triennially })
        }
        hint="Supports also {{PER_MONTH}}, {{PER_YEAR}}, {{PER_TRIENNIAL}} and {{SAVINGS}} tokens."
      />
    </InputSection>

    <InputSection title="Licenses number picker">
      <TextInput
        label="Title"
        value={value.licenses_count_title}
        onChange={(licenses_count_title) =>
          onChange({ ...value, licenses_count_title })
        }
      />

      <TextInput
        label="Max licenses count message"
        value={value.licenses_count_max_message}
        onChange={(licenses_count_max_message) =>
          onChange({ ...value, licenses_count_max_message })
        }
        hint="Supports markdown"
      />
    </InputSection>

    <InputSection title="Main pricing card lables">
      <TextInput
        label="Main card button label for disabled state"
        value={value.main_card_disabled_button_label}
        onChange={(main_card_disabled_button_label) =>
          onChange({ ...value, main_card_disabled_button_label })
        }
      />

      <TextInput
        label="Main card button label for disabled state (laptop screens)"
        value={value.main_card_disabled_button_laptop_label}
        onChange={(main_card_disabled_button_laptop_label) =>
          onChange({ ...value, main_card_disabled_button_laptop_label })
        }
      />
    </InputSection>
  </InputSection>
);

const PricingLabelsInput = ({ value, name }) => {
  const [settings, setSettings] = React.useState(value);

  return (
    <RaketaUIProvider>
      <MediaManagerContext.Provider value={mediaManager}>
        <LabelsInput value={settings} onChange={setSettings} />

        <input
          type="hidden"
          name={name}
          defaultValue={JSON.stringify(settings)}
        />
      </MediaManagerContext.Provider>
    </RaketaUIProvider>
  );
};

export default PricingLabelsInput;
